import './forkscorks/style';
import FormStructure from './forkscorks/form_structure';

export default FormStructure;